
/* injects from baggage-loader */

'use strict';

import moment from 'moment';

export default class ProjectController {

	constructor($log, $timeout, $state, $scope, User, Alerts, Parse, ProjectSectionSchema, ProjectRewardSchema) {
		'ngInject';

		this.$log = $log;
		this.$timeout = $timeout;
		this.$state = $state;
		this.$scope = $scope;
		this.User = User;
		this.Alerts = Alerts;
		this.Parse = Parse;
		this.ProjectSectionSchema = ProjectSectionSchema;
		this.ProjectRewardSchema = ProjectRewardSchema;

		// Smallest amount allowed to invest
		this.default_investment_min = 5;

		// Initialize info sections
		this.sections = [];
		this.rewards = [];

		// Initalize comments
		this.comments = [];
		this.topLevelComments = [];
		this.showCommentBox = false;

		// Initialize documents
		this.documents = [];

		// Admin stuff
		this.isEditingProject = false;

		// Investment button text
		this.invest_button_text = 'Donate Now';
		this.invest_button_closed_text = 'Raise concluded';

	}

	$onInit() {
		// this.$log.log('Project:', this.project);
		// this.$log.log(this.comments);
		// this.$log.log(this.documents);
		// this.$log.log(this.rewards);

		// Override donate now button if no stripe account linked
		if (!this.project.stripe_account_id) {
			this.invest_button_text = 'Not accepting donations'
		}

		// Find all top level comments (comments without parents)
		this.topLevelComments = this.comments.filter(comment => typeof comment.get('parent') === 'undefined');

		// Fetch project info sections
		// let query = this.project.get('sections').query();
		// query.find().then(sections => {
		// 	this.sections = sections;
		// });


		// Listen for changes in the section order
		this.$scope.$on('projectSectionOrderChanged', (event, options) => {

			// Find the current section
			let section = this.sections.find(s => s.id === options.id);

			// Find the neighboring section based on direction
			let neighbor = this.sections[options.direction === 'up' ? options.index - 1 : options.index + 1];

			if (neighbor) {

				// Set new order values
				if (options.direction === 'up') {
					neighbor.order = options.index + 1;
					section.order = options.index - 1;
				} else {
					neighbor.order = options.index - 1;
					section.order = options.index + 1;
				}

			}

		});

		// Listen for requests to remove project sections
		this.$scope.$on('removeProjectSection', (event, id) => {

			// Remove the section
			let section = this.sections.find(s => s.id === id);
			if (section) {
				let section_idx = this.sections.findIndex(s => s.id === id);
				this.sections.splice(section_idx, 1);
				section.destroy();
			}

			// TODO: Refresh all order values, how?

		});

		// Listen for requestrs to remove pledge rewards
		this.$scope.$on('removePledgeReward', (event, id) => {

			// Remove the reward
			let reward = this.rewards.find(r => r.id === id);
			if (reward) {
				let idx = this.rewards.findIndex(r => r.id === id);
				this.rewards.splice(idx, 1);
				reward.destroy();
			}

		});

	}


	// TODO: verify this function outputs "1" day remaining up until midnight of the end_date
	// 			 "Midnight" as in 23:59:59 in the local tz
	/**
	 * Returns the number of days remianing until the end of the raise
	 */
	daysRemaining() {
		let days = moment(this.project.get('end_date')).diff(moment(), 'days');
		let exact = moment(this.project.get('end_date')).diff(moment(), 'days', true);
		if (exact > 0 && exact < 1) {
			days = 1;
		}
		return days > 0 ? days : 0;
	}


	/**
	 * Returns true if the raise is still open to donations
	 */
	isRaiseOpen() {
		return this.daysRemaining() > 0 ? true : false;
	}


	/**
	 * Show the comment box
	 */
	revealCommentBox() {
		this.showCommentBox = true;
	}

	/**
	 * Method called after a top level comment is posted
	 */
	commentPosted() {
		// Display local alert
		this.Alerts.setLocal({
			msg: 'Comment posted successfully',
			type: 'success'
		});
	}


	/**
	 * Returns true when the current user is the owner of the project
	 */
	isProjectOwner() {
		let currentUser = this.User.getCurrent();
		let ACL = this.project.getACL();
		if (currentUser && ACL) {
			return ACL.getWriteAccess(currentUser.id);
		}
	}


	/**
	 * Toggles the project into editing mode
	 */
	toggleEditing() {
		if (this.isProjectOwner() === true) {
			if (this.isEditingProject === true) {
				if (this.project.dirty() === true) {
					alert('Please "Discard" or "Save" changes before leaving editing mode');
					return false;
				}
				this.isEditingProject = false;
			} else {
				this.isEditingProject = true;
			}
		}
	}


	/**
	 * Creates a new project info section
	 */
	newSection() {
		this.sections.push(new this.ProjectSectionSchema({
			order: this.sections.length
		}));
	}


	/**
	 * Creates a new pledge reward
	 */
	newReward() {
		this.rewards.push(new this.ProjectRewardSchema({
			Project: this.project
		}));
	}


	/**
	 * Returns true if the project or any section has been modified
	 */
	isProjectDirty() {
		return this.project.dirty() || Boolean(this.sections.find(s => s.dirty())) || Boolean(this.rewards.find(s => s.dirty()));
	}

	whatIsDirty() {
		this.$log.log('Project', this.project.dirtyKeys())
		for (let s of this.sections) {
			this.$log.log(s.title, s.dirtyKeys())
		}
		for (let r of this.rewards) {
			this.$log.log(r.title, r.dirtyKeys())
		}
	}

	/**
	 * Discards any changes to the object
	 */
	async discardChanges() {

		// Destory unsaved sections
		let sectionsRelation = this.project.op('sections');
		let sectionsToAdd = sectionsRelation ? sectionsRelation.relationsToAdd : [];
		for (let id of sectionsToAdd) {
			let section = this.sections.find(s => s.id === id);
			if (section) {
				let idx = this.sections.findIndex(s => s.id === id);
				this.sections.splice(idx, 1);
				section.destroy();
			}
		}

		// Destory unsaved rewards
		let rewardsRelation = this.project.op('pledge_rewards');
		let rewardsToAdd = rewardsRelation ? rewardsRelation.relationsToAdd : [];
		for (let id of rewardsToAdd) {
			let reward = this.rewards.find(r => r.id === id);
			if (reward) {
				let idx = this.rewards.findIndex(r => r.id === id);
				this.rewards.splice(idx, 1);
				reward.destroy();
			}
		}

		// Discard any changes to the project and info sections
		this.project.revert();
		this.sections.map(section => {
			section.shouldDelete = false;
			section.revert();
		});
		this.rewards.map(reward => {
			reward.shouldDelete = false;
			reward.revert();
		});

		// Reload the project
		// this.$state.reload();

	}


	/**
	 * Save any changes to the object to the server
	 */
	async saveChanges() {

		// let rewardsRel = this.project.op('pledge_rewards');
		// this.$log.log('Add Rewards:', rewardsRel ? rewardsRel.relationsToAdd : 'none');
		// this.$log.log('Remove Rewards:', rewardsRel ? rewardsRel.relationsToRemove : 'none');

		// Destory removed sections
		let sectionsRelation = this.project.op('sections');
		let sectionsToRemove = sectionsRelation ? sectionsRelation.relationsToRemove : [];
		for (let id of sectionsToRemove) {
			let section = this.sections.find(s => s.id === id);
			await section.destroy();
			let section_idx = this.sections.findIndex(s => s.id === id);
			this.sections.splice(section_idx, 1);
		}

		// Destory removed rewards
		let rewardsRelation = this.project.op('pledge_rewards');
		let rewardsToRemove = rewardsRelation ? rewardsRelation.relationsToRemove : [];
		for (let id of rewardsToRemove) {
			let reward = this.rewards.find(r => r.id === id);
			await reward.destroy();
			let idx = this.rewards.findIndex(r => r.id === id);
			this.rewards.splice(idx, 1);
		}

		// Save any dirty info sections
		let dirty_sections = this.sections.filter(s => s.dirty() && !sectionsToRemove.includes(s.id));
		await this.Parse.Object.saveAll(dirty_sections);

		// Save any dirty rewards
		let dirty_rewards = this.rewards.filter(r => {
			if (r.dirty() && !rewardsToRemove.includes(r.id)) {
				// Fix amount if user never finished editing before saving
				if (typeof r.amount === 'string') {
					r.amount = parseInt(r.amount.replace(/\D/g, ''));
				}
				return r;
			}
		});
		await this.Parse.Object.saveAll(dirty_rewards);

		this.project.save()
			.then(_project => {
				this.$log.log('Saved changes');

				// TODO: enable this after testing
				this.$state.reload();
			});
	}

}



// WEBPACK FOOTER //
// ./src/app/pages/project/project.controller.js